var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOpenInNewTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none",
    viewBox: "0 0 21 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#081132",
    fillRule: "evenodd",
    d: "M0 5.146C0 2.304 2.304 0 5.146 0H9c.677.022 1.22.578 1.22 1.26S9.677 2.498 9 2.52v.004H5.146c-1.448 0-2.622 1.174-2.622 2.622v9.708c0 1.448 1.174 2.622 2.622 2.622h9.709c1.447 0 2.621-1.174 2.621-2.622V11.5h.005l-.001-.04c0-.697.564-1.26 1.26-1.26.696 0 1.26.563 1.26 1.26v3.394C20 17.696 17.697 20 14.855 20h-9.71C2.305 20 0 17.696 0 14.854V5.146zm10.116 3.002c-.488.488-.488 1.28 0 1.768s1.28.488 1.768 0l5.652-5.652v1.535c0 .69.56 1.25 1.25 1.25s1.25-.56 1.25-1.25V1.3c0-.17-.034-.332-.096-.48-.185-.46-.635-.783-1.16-.783h-4.5c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25h1.448l-5.612 5.612z",
    clipRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenInNewTab);
export default __webpack_public_path__ + "static/media/open-in-new-tab.52ad7830.svg";
export { ForwardRef as ReactComponent };